<template>
    <div class="tz-tips" @click="showTips = !showTips" @mouseenter="showTips = true" @mouseleave="showTips = false">
        {{short}}
        <div class="tz-tip" v-if="showTips">{{whole}}</div>
    </div>
</template>
<script>
export default {
    props:{
        content:{
            type: String,
            default: ''
        },
        len:{
            type: Number,
            default: 7
        }
    },
    data(){
        return {
            short: '',
            whole: '',
            showTips: false
        }
    },
    mounted(){
        this.whole =this.content
        if(this.content.length>this.len){
            this.short = this.content.substring(0,this.len)+".."
        }else{
            this.short = this.content
        }
    },
    watch:{
        content:{
            handler(nv,ov){
                this.whole =this.content
                if(this.content.length>this.len){
                    this.short = this.content.substring(0,this.len)+".."
                }else{
                    this.short = this.content
                }
            }
        }
    }
}
</script>
<style scoped>
.tz-tips{
    display: inline-block;
    width: 100%;
    white-space: nowrap;
}
.tz-tip{
    position:absolute;
    display: block;    
    background: wheat;
    white-space: nowrap;
    border-radius: 5px;
    padding: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/tips.vue